import React from 'react';
import {Line} from 'react-chartjs-2';
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
    ChartDataLabels
);

const LineChart = ({title, values}) => {
    if (!values.length) return null;

    const labels = values.map(item => item[0]);
    const solvedData = values.map(item => item[1]);
    const notSolvedData = values.map(item => item[2]);

    const data = {
        labels,
        datasets: [
            {
                label: 'Решённые',
                data: solvedData,
                borderColor: 'blue',
                backgroundColor: 'blue',
                tension: 0.3,
                pointRadius: 8,
                datalabels: {color: 'white'}
            },
            {
                label: 'Нерешённые',
                data: notSolvedData,
                borderColor: 'red',
                backgroundColor: 'red',
                tension: 0.3,
                pointRadius: 8,
                datalabels: {color: 'white'}
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {display: true, text: title, font: {size: 18, weight: 'bold'}},
            legend: {position: 'top'},
            tooltip: {mode: 'index', intersect: false},
        },
        scales: {
            x: {
                title: {display: true, text: 'Дата', font: {size: 14}},
                ticks: {maxRotation: 45, minRotation: 45, font: {size: 10}},
            },
            y: {
                title: {display: true, text: 'Количество', font: {size: 14}},
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                    precision: 0,
                    callback: (value) => (Number.isInteger(value) ? value : null),
                    font: {size: 12}
                },
            },
        },
    };

    return <Line data={data} options={options} plugins={[ChartDataLabels]}/>

};

export default LineChart;
